import { render, staticRenderFns } from "./AttributeManager.vue?vue&type=template&id=dd1ecdce&scoped=true"
import script from "./AttributeManager.vue?vue&type=script&lang=ts"
export * from "./AttributeManager.vue?vue&type=script&lang=ts"
import style0 from "./AttributeManager.vue?vue&type=style&index=0&id=dd1ecdce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1ecdce",
  null
  
)

export default component.exports